import { useTranslation } from "react-i18next";
import cn from "classnames";
import { Badge, BadgeType } from "@components/new/Badge";
import { Title2, SubTitle3 } from "@components/new/Typo";
import { Tooltip } from '@components/new/Tooltip';
import { IconButton, IconButtonSize, IconButtonType } from "@components/new/IconButton";
import YmBadge from "./YmBadge";
import MoveIcon from '@assets/icons/outline/arrow-left-right.svg?react';
import DelIcon from '@assets/icons/outline/trash-2.svg?react';
import WarningIcon from "@assets/icons/solid/circle-alert.svg?react";
import styles from './Form.module.scss';

const StoreItem = ({
  title,
  subtitle,
  status,
  isMovingBlocked,
  isDeletionBlocked,
  onMoveStore,
  onDelStore,
  isNewLinkToMove,
  isAwaitingDeletion,
  hideMove,
  hideDel,
  placementType,
}: {
  isAwaitingDeletion: boolean;
  title: string;
  subtitle: string;
  status?: string;
  isMovingBlocked?: boolean;
  isDeletionBlocked?: boolean;
  onMoveStore: () => void;
  onDelStore: () => void;
  isNewLinkToMove?: boolean;
  hideMove?: boolean;
  hideDel?: boolean;
  placementType?: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.storeItem}>
      <div className={styles.storeItemLeft}>
        <Title2>{title}</Title2>
        {subtitle ? <SubTitle3 color="grey-700">{subtitle}</SubTitle3> : null}
      </div>

      <div className={styles.storeItemRight}>
        {isAwaitingDeletion ? (
          <Badge type={BadgeType.DESTRUCTIVE} className={styles.badge}>
            {t("fbpPage.removalInProces")}
          </Badge>
        ) : (
          <>
            {["Expiring", "Expired", "Invalid"].find(
              (v) => v === status,
            ) ? (
              <div className={styles.status}>
                <WarningIcon
                  className={cn(
                    styles.icon,
                    styles[`icon-${status}`],
                  )}
                />
                <SubTitle3>
                  {t(`storesPage.tokenStatus.${status}`)}
                </SubTitle3>
              </div>
              ) : null}

              <YmBadge placementType={placementType} />

              {isNewLinkToMove || hideMove ? null : (
              <Tooltip
                action={(
                  <IconButton
                    type={IconButtonType.ICON}
                    size={IconButtonSize.S}
                    icon={MoveIcon}
                    onClick={onMoveStore}
                    disabled={isMovingBlocked}
                  />
                )}
                position="top"
                text={isMovingBlocked ? t("fbpPage.addWarehouseModal.activeOrdersTooltip") : ""}
                whiteSpace="pre-wrap"
              />
            )}

            {hideDel ? null : (
              <Tooltip
                action={(
                  <IconButton
                    type={IconButtonType.ICON}
                    size={IconButtonSize.S}
                    icon={DelIcon}
                    onClick={onDelStore}
                    disabled={isDeletionBlocked}
                  />
                )}
                position="top"
                text={isDeletionBlocked ?
                  t("fbpPage.delStoreModal.delUnavailableTooltip") :
                  t("fbpPage.delStoreModal.delAvailableTooltip")
                }
                  whiteSpace="pre-wrap"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default StoreItem;
